var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaAproximacin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7551bc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-aproximaci\xF3n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_13",
    "data-name": 13
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,146.28a.52.52,0,0,0,.51.25h32.38a1.46,1.46,0,0,1,1.08.45,1.44,1.44,0,0,1,.45,1.08v15a1.47,1.47,0,0,1-.45,1.08,1.45,1.45,0,0,1-1.08.44H114.12a1.45,1.45,0,0,1-1.08-.44,1.46,1.46,0,0,1-.44-1.08v-14.1a2.57,2.57,0,0,1,.76-1.9q7.62-7.11,20.19-20.44l7.62-8q11.55-11.94,11.55-17.4A7.8,7.8,0,0,0,150,95.1a10.29,10.29,0,0,0-7.05-2.41,10,10,0,0,0-7,2.41,8.16,8.16,0,0,0-2.67,6.35v3a1.49,1.49,0,0,1-.44,1.08,1.46,1.46,0,0,1-1.08.44H113.48a1.46,1.46,0,0,1-1.08-.44,1.49,1.49,0,0,1-.44-1.08V98.15a22.24,22.24,0,0,1,4.7-12.44,26.72,26.72,0,0,1,11-8.19,39.14,39.14,0,0,1,15.23-2.86,36.73,36.73,0,0,1,16.45,3.49,26,26,0,0,1,10.79,9.46,24.22,24.22,0,0,1,1.21,23.75,53.67,53.67,0,0,1-7.62,11.3q-3.56,4.32-8,8.76t-12.32,11.94l-2.54,2.41A.42.42,0,0,0,140.78,146.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.77 102.11 96.45 94.79 78.95 112.29 61.45 94.79 54.13 102.11 71.62 119.61 54.13 137.11 61.45 144.43 78.95 126.94 96.45 144.43 103.77 137.11 86.27 119.61 103.77 102.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaAproximacin);
export default __webpack_public_path__ + "static/media/ic-alerta-aproximación.edb448e9f086af28071db4616a55eabc.svg";
export { ForwardRef as ReactComponent };